import React from 'react';
import { SunIcon, RainIcon, ShieldIcon } from './icons';
import { WARRANTY_YEARS } from '../config/warranty';

// CompareClaims — the four-bullet trust strip shown on each
// product compare card (awnings, pergolas). Extracted from
// HomePage.js per CQ-23 Phase B since multiple section
// components consume it.
//
// `warranty` defaults to the range-wide warranty (see config/warranty.js).
export default function CompareClaims({ warranty = `${WARRANTY_YEARS} Year Warranty` }) {
  return (
    <ul className="asg-compare-claims">
      <li><SunIcon />Sun Protection</li>
      <li><RainIcon />Water-Resistant</li>
      <li><ShieldIcon /><strong>{warranty}</strong></li>
    </ul>
  );
}
